import React from 'react'
// Firebase auth redirect — must run BEFORE React renders
// Firebase reset links arrive as: /reset-password?mode=resetPassword&oobCode=xxx
// HashRouter needs: /#/reset-password?mode=resetPassword&oobCode=xxx
;
(function firebaseAuthRedirect() {
  const path = window.location.pathname;
  const search = window.location.search;
  const hash = window.location.hash;
  const isProduction = process.env.NODE_ENV === 'production';
  const isHashRouter = isProduction || window.location.href.includes('use-hash-router=true');
  if (isHashRouter && path === '/reset-password' && search.includes('oobCode') && !hash) {
    console.log('RESET REDIRECT RUNNING');
    window.location.replace(window.location.origin + '/#' + path + search);
    // Stop execution — page will reload with hash URL
    throw new Error('Redirecting to hash route');
  }
})();
import './index.css';
import { createRoot } from 'react-dom/client';
import { App } from './App';
const container = document.getElementById('root');
if (!container) throw new Error('Failed to find the root element');
const root = createRoot(container);
root.render(<React.StrictMode data-id="element-3045">
    <App data-id="element-3046" />
  </React.StrictMode>);